// client/src/pages/RefundPage.jsx
import React from "react";
import LegalLayout from "./LegalLayout.jsx";
import LegalPageBody from "./LegalPageBody.jsx";

export default function RefundPage() {
  return (
    <LegalLayout pageKey="refund">
      {({ lang }) => <LegalPageBody slug="refund" lang={lang} />}
    </LegalLayout>
  );
}
